module.exports = __webpack_public_path__ + "static/img/hotkid.7d41d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/picture_show/hotkid.jpg
// module id = s5jB
// module chunks = 1